<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
 

      <template v-slot:activator="{ on, attrs }">
       
       <v-btn 
       v-bind="attrs"
          v-on="on"
          icon
          data-cy="add-opcion-input"
       @click="opcionEditImg" 
       >
       
       <v-icon left>mdi-image-edit</v-icon></v-btn>
       
      </template>

      <v-card>
      

        <v-card-text>
          {{opcion}}
          --------------------------------------------
          {{opcion.principal}}
          <v-container>
    <v-row>

        <v-col cols="12">
          <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
 <v-row no-gutters>
    </v-row>
    
  
      <v-col cols="12">

<v-avatar
:size="zoom*2"
>
    
 <a data-fancybox data-caption="Single image" :href="server_url+'api/opcion/get_image_opcion/'+opcion.principal_id+'/'+ opcion.linkPhoto">
        <img :src="server_url +'api/opcion/get_image_opcion/'+opcion.principal_id+'/'+opcion.linkPhoto" style="height:20vh" />
      </a>

    </v-avatar>

 <v-card-text>
      <v-slider
        v-model="zoom"
        append-icon="mdi-magnify-plus-outline"
        prepend-icon="mdi-magnify-minus-outline"
        @click:append="zoomIn"
        @click:prepend="zoomOut"
      ></v-slider>
    </v-card-text>


          <v-file-input
            v-if="!fileData.url"
            v-model="archivo"
            show-size
            chips
            label="Adjuntar Imagen"
            prepend-icon="mdi-file"
            @change="uploadFile"
            ref="file_perfil"
            data-cy="file-input"
          ></v-file-input>
          <div v-if="fileData.url">
            <p>Archivo Agregado</p>
            <span>
              <a :href="server_url +'api/opcion/get_image/'+ fileData.url">
                {{ fileData.name }}
                <v-icon color="blue">mdi-download</v-icon>
              </a>
              <button @click="removeFile()">
                <v-icon color="red">mdi-delete</v-icon>
              </button>
            </span>
          </div>
   


      </v-col>

    <v-col
        cols="12"
        md="12"
      >

      <v-text-field
           v-model="opcion.descripcion"
           label="Descripcion"
           :counter="2"
           :rules="textRules"
           disabled
         ></v-text-field>

          

   
 <v-text-field
           v-model="opcion.link"
           label="Link"
           disabled
         ></v-text-field>




       
      </v-col>

      <v-divider></v-divider>

        <v-card-actions>

            <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="registrarOpcion"
      >
        Registrar
      </v-btn>

     

          <v-spacer></v-spacer>
           <v-btn
        color="error"
        class="mr-4"
        @click="dialog = false"
      >
        Cancelar
      </v-btn>
        </v-card-actions>

      
    </v-form> 

        </v-col>
    </v-row>
  </v-container>

        </v-card-text>

        
      </v-card>
    </v-dialog>
  </div>
</template>


<script>


import opcionService from "@/services/opcionService.js";

import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';


import { http } from "@/services/config";


  export default {
    name:"OpcionImg",

     props: {
    opcionData: {
      type: Object, 
      default: () => ({}) 
    },
    principalData: {
      type: Object, 
      default: () => ({}) 
    }

  },

    data: () => ({
       zoom: 50,
      archivo: null,
      fileData: {
        url: "",
        name:""
      },
       server_url: "",
       opcion:{

descripcion:'',
link:'',
linkPhoto:'',
tipo:'',
observacion:'',
id:'',
color:'#1F7087',
icon:'mdi-instagram',
principal:{}

          
        }
    ,
       valid: false,
    rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                  emailMatch: () => (`The email and password you entered don't match`),
                },
        	messages:undefined,
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 1) || "Debe contener al menos 3 caracteres",
            ],
        
            emailRules:  [
              (v) => !!v || "Correo es requerido",
              (v) => /.+@.+\..+/.test(v) || "Correo debe ser valido",
            ],
             numberRules: [
              (v) => (v >= 0) || "Valor debe ser mayor o igual a 0",
            ],
      dialog:false,
    }),
  created(){

       }
  ,mounted(){

  Fancybox.bind(this.$refs.container, '[data-fancybox]', {
      ...(this.options || {}),
    });

     this.server_url = http.defaults.baseURL;
    
    },

    methods:{
     zoomOut () {
        this.zoom = (this.zoom - 20) || 0
      },
      zoomIn () {
        this.zoom = (this.zoom + 20) || 200
      },
     uploadFile: function () {
      this.opcion.linkPhoto=this.fileData.url;
      if (this.archivo) this.submitFile();
      else this.removeFile();
    },
    submitFile() {

      this.fileData.name=this.archivo.name;
      console.log(this.archivo);
      const formData = new FormData();
      formData.append("file_opcion", this.archivo);
      formData.append("opcion", JSON.stringify(this.opcion));
    //  formData.append('data', this.opcion);
      //formData.append("identificador", this.principal.identificador);
      formData.append("opcion_id", this.opcion.id);
      formData.append("identificador", this.opcion.principal_id);
      const headers = { "Content-Type": "multipart/form-data" ,
      'Authorization':'Bearer '+ localStorage.getItem("token")};

      console.log(formData);
      http
        .post(this.server_url + "api/opcion/save_img_opcion/"+this.opcion.id, formData, { headers })
        .then((res) => {
          //res.data.files; // binary representation of the file
          //res.status; // HTTP status
         // this.fileData = res.data.opcion;
      //    console.log(this.fileData.url);
         // console.log(res.data);

         this.opcion.linkPhoto=res.data.opcion.linkPhoto;
         this.fileData.url=res.data.opcion.linkPhoto;

         console.log(this.opcion.linkPhoto);
        });
    },
    removeFile() {
        this.fileData = { url: "" };
      
        this.archivo=null;

        this.opcion.linkPhoto='';
  
    },

     opcionEditImg(){
      console.log(this.opcionData);
      this.opcion=this.opcionData;
      //utilizado para almacenar la imagen en la carpeta del identificador
      this.opcion.principal=this.principalData;
    },
    
    colorEdit(){
      console.log(this.color);
    },
    registrarOpcion(){

            if (this.$refs.form.validate()) {

              let res;
   // this.redirect='/opcion';

  console.log('El ide esta vacio '+this.opcion.id);

  
     //   this.opcion.color='#1F7087';
    if(this.opcion.id===""){

        console.log('El ide esta vacio '+this.opcion.id);

            opcionService.save(this.opcion).then(
        response =>{
            res= response.data.status,
            console.log('success');

            console.log(response.data);
       
        }).catch((errors) =>{

           console.log('error');
            console.log(errors);
        })
        console.log(res);
            
            this.$emit('opcionEditImg',this.opcion);
            this.dialog=false;
            
    }else{

      console.log("Ingrese a actualizar");
    opcionService.update(this.opcion).then(
        response =>{
            res= response.data.status,
            console.log('success');

            console.log(response.data);
       
        }).catch((errors) =>{

           console.log('error');
            console.log(errors);
        })
        console.log(res);
            }
            this.$emit('opcionEditImg',this.opcion);
            this.dialog=false;
        }
        
        }

        
        ,
    validate(){
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
    ,
    limpiar(){

     
		this.opcion={
				nombre:'',
        apellido:'',
				linkPhoto:'',
				descripcion:'',
				observacion:'',
				id:'',
	}
    },

    },

    computed: {
      
      
    },
  watch: {
    
  }
  }
</script>